<!--
/*******************************************************************************
*@ 컴포넌트명   : Product1101001000011ogcbd.vue
*@ 컴포넌트설명 :[캄보디아] 예금 상품 > 예금 상품 상세(개인당좌예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <section class="deposit detail">
    
    <!--한국어-->
    <template v-if="lang == $config.LANG_KOR">
      <div class="scroll">
        <article class="content-header bg-type">
            <div class="title">
              <h2>개인당좌예금</h2>
            </div>
            <div class="description">
              <p>
                가계당좌 결제용 입출금이 자유로운 통장
              </p>
            </div>
          </article>
          <article class="contents">
            <dl class="dlist dlist-item--type5">
              <dt>상품유형</dt>
              <dd>당좌예금</dd>
              <dt>상품개요</dt>
              <dd>가계당좌 결제용 입출금이 자유로운 통장</dd>
              <dt>가입대상</dt>
              <dd>18세 이상 성인</dd>
              <dt>계약 기간</dt>
              <dd>제한없음</dd>
              <dt>가입통화</dt>
              <dd>USD, KHR</dd>
              <dt>가입금액</dt>
              <dd>신규가입 시 최저 USD 1,000.00 이상</dd>
              <dt>금리 및 이율</dt>
              <dd>약정이율 연 0.00% (USD 및 KHR 공통적용)</dd>
              <dt>수수료</dt>
              <dd>해당무</dd>
              <dt>가입방법</dt>
              <dd>영업점가입</dd>
              <dt>가입시 필요서류</dt>
              <dd>ID 카드, 여권 등 실명확인증표</dd>
            </dl>
          </article>
      </div>
    </template>
    <!--영어-->
    <template v-else-if="lang == $config.LANG_ENG">
      <div class="scroll">
        <article class="content-header bg-type">
            <div class="title">
              <h2>Personal Checking Account</h2>
            </div>
            <div class="description">
              <p>
                Saving with free deposit and withdrawal by using slip and check book.
              </p>
            </div>
          </article>
          <article class="contents">
            <dl class="dlist dlist-item--type5">
              <dt>Types</dt>
              <dd>Checking Account</dd>
              <dt>About the products</dt>
              <dd>Saving with free deposit and withdrawal by using slip and check book.</dd>
              <dt>Eligibilty</dt>
              <dd>Adults over 18 years old</dd>
              <dt>Contract Terms</dt>
              <dd>No restrictions</dd>
              <dt>Available currency</dt>
              <dd>USD, KHR</dd>
              <dt>Deposit amount</dt>
              <dd>To open a new account, a minimum USD 1,000.00 deposit amount is required.</dd>
              <dt>Rates</dt>
              <dd>Agreed interest rate of 0.00% annually (for both USD and KHR)</dd>
              <dt>Fees</dt>
              <dd>N/A</dd>
              <dt>How to apply</dt>
              <dd>Apply at the branch</dd>
              <dt>Required documents for application</dt>
              <dd>ID card, passport, identity verification, etc.</dd>
            </dl>
          </article>
      </div>
    </template>
    <!--캄보디아어-->
    <template v-else>
      <div class="scroll">
        <article class="content-header bg-type">
            <div class="title">
              <h2>គណនីចរន្ដ</h2>
            </div>
            <div class="description">
              <p>
                គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រ
              </p>
            </div>
            <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
            <!--// 금리 이율 + 최소가입금액 있을 경우 end -->
          </article>
          <article class="contents">
            <dl class="dlist dlist-item--type5">
              <dt>ប្រភេទផលិតផល</dt>
              <dd>Checking Account</dd>
              <dt>មាតិកាផលិតផល</dt>
              <dd>គណនីដែលអាចសន្សំ និងដកប្រាក់ដោយប្រើប័ណ្ណរឺមូលប្បទានប័ត្រ</dd>
              <dt>អតិថិជនគោលដៅ</dt>
              <dd>អ្នកដែលមានអាយុចាប់ពី១៨ឆ្នាំឡើងទៅ</dd>
              <dt>រយៈពេលកិច្ចសន្យា</dt>
              <dd>មិនមានកំនត់</dd>
              <dt>ប្រភេទរូបិយប័ណ្ណដែលស្នើសុំ</dt>
              <dd>USD, KHR</dd>
              <dt>ចំនួនទឹកប្រាក់ដែលស្នើសុំ</dt>
              <dd>ចំនួនទឹកប្រាក់ដំបូងតិចបំផុត USD1,000.00</dd>
              <dt>អត្រាការប្រាក់</dt>
              <dd>ក្នុងកិច្ចសន្យា ការប្រាក់ក្នុងមួយឆ្នាំ0.00% (ប្រាក់រៀលនិងប្រាក់ដុល្លាគិតដូចគ្នា)</dd>
              <dt>កំរៃសេវា</dt>
              <dd>គ្មាន</dd>
              <dt>របៀបចុះឈ្មោះ</dt>
              <dd>ចុះឈ្មោះនៅសាខា</dd>
              <dt>តំរូវការឯកសារចុះឈ្មោះ</dt>
              <dd>អត្តសញ្ញាណប័ណ្ណ រឺ លិខិតឆ្លងដែន ។ល។</dd>
            </dl>
          </article>
      </div>
    </template>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed:{
    ...mapFields(["lang"]),
  }
};
</script>
